import React from "react";

/** Content wrapper only; shell (sidebar) comes from MainAppLayout. */
const TabPageLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div className="max-w-[1304px] mx-auto px-[10px] py-[10px] md:px-[30px] md:py-[30px]">
    {children}
  </div>
);

export default TabPageLayout;
